export default __webpack_public_path__ + "static/media/ticket37.5aa92008.jpg";